module.exports = __webpack_public_path__ + "static/media/icon-arrow-right-hover.e31a81ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-arrow-right-hover.svg
// module id = 167
// module chunks = 0